export enum EUserRole {    
    Administrator,
    ShipperLogist,
    ShipperLogistExtended,
    CargoTransporterLogist,
    CargoTransporterLogistExtended,
    ErpUser,
    Driver
}